module.exports = __webpack_public_path__ + "img/104.939d6cf6.jpg";